import {useCallback, useRef, useState, useEffect} from 'react'

// Shared helpers for the react-select style components.
// It allows searching by subtitle in the options and adds some state helpers.
const useSelectEvents = ({onInit, onChange}) => {
  const wrapperRef = useRef(null)
  const selectRef = useRef(null)
  const [menuIsOpen, setMenuIsOpen] = useState(false)
  const [changeInProgress, setChangeInProgress] = useState(false)

  // Hack for bubbling 'change' events:
  // focus and blur events naturally bubble from the underlying ReactSelect component.
  // default/native change events do not bubble, so we have to manually (re-) dispatch them with {bubbles: true} here.
  // setting handlers on for these events has tricks:
  // $form.on('change', 'input, select')  -> will not work. the synthetic event comes from a div
  // $form.on('change', 'div') -> will work but will get an event per div that is bubbled through.
  // $form.on('change', 'div.js-slick-auto-save') -> will work correctly, assuming that exactly one div has that class.
  const handleChange = useCallback((newValue) => {
    if (wrapperRef.current) {
      wrapperRef.current.dispatchEvent(new Event('change', {bubbles: true, cancelable: true}))
      if (onChange && typeof onChange === 'function')
        onChange(newValue, wrapperRef.current)
    }
  }, [wrapperRef, onChange])

  useEffect(
    () => {
      if (wrapperRef.current && onInit && typeof onInit === 'function')
        onInit(wrapperRef.current)
    },
    [wrapperRef, onInit],
  )

  return {handleChange,
    wrapperRef,
    selectRef,
    menuIsOpen,
    setMenuIsOpen,
    changeInProgress,
    setChangeInProgress}
}

export default useSelectEvents
